import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { ErrorComponent } from 'app/popup/error.component';
import { AlertComponent } from 'app/popup/alert.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { StatusService } from 'app/services/status.service';
import { ToastrService } from 'ngx-toastr';
import { CountryService } from 'app/services/country.service';
import { PlaceService } from 'app/services/place.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-manage-countries',
  templateUrl: './manage-countries.component.html',
  styleUrls: ['./manage-countries.component.css']
})
export class ManageCountriesComponent implements OnInit {

  countries: any = [];

  removeRef: any;
  page = 1;
  lblHeading = 'Countries';
  showNum: number = 10;

  popoverTitle = 'Delete Status';
  popoverMessage = 'Are you sure you want to Delete Status?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  countryPlaceFlag: boolean = false;
  public isLoading = false;
  isEmpty: boolean = false;
  message = "Loading Countries...";
  placesList: any = [];
  selectCountry: any = Object();
  reloadTypeId: any = ""
  constructor(private statusService: StatusService,
    private countryService: CountryService,
     public utility: UtilityServiceService, private toastr: ToastrService,
    private placeService: PlaceService, private router: ActivatedRoute, private route: Router) { }

  ngOnInit() {
    this.utility.setDirection(true);
    this.utility.page = 1;
    let type: any = this.router.params['_value'].type;
    if (type != undefined && type != "") {
      this.countryPlaceFlag = true;
      this.reloadTypeId = atob(type);
    }
    this.reload();


  }
  reload() {
    this.isLoading = true;
    this.countryService.listAllCountries().subscribe(res => {
      this.isLoading = false;
      this.countries = res;
      this.utility.onSort(5);
      if (this.countryPlaceFlag) {
        this.selectCountry = this.countries.find(({ id }) => +id === parseInt(this.reloadTypeId));
      }
      
      this.countries.sort((a, b) => {
        const compare_code = a.code.localeCompare(b.code);
        const compare_desc = a.desc.localeCompare(b.desc);
        const compare_group_code = a.group_code.localeCompare(b.group_code);

        return compare_code || compare_desc || compare_group_code;
      });
    })

  }
  loadCountryDetails(list) {
    this.lblHeading = "Places";
    //this.countryPlaceFlag=true;
    //this.selectCountry=list;
    this.route.navigate(['countries/list/' + btoa(list.id)]);
  }
  loadPlace(list) {
    this.route.navigate(['countries/list/' + btoa(list.id)]);
  }

}
